export default () =>
  import(/* webpackChunkName: 'coffee/app/agreement/vip-pay' */ './VipPay');
